import { Brand, createBranded } from '@deltasierra/type-utilities';

export type LocalMediaPublishContentId = Brand<number, 'LocalMediaPublishContentId'>;
export const LocalMediaPublishContentId = createBranded<LocalMediaPublishContentId>();
